import type { Abstract } from './utility';

export type PluginId = Abstract<string, 'PluginId'>;
